import { useEffect, useState } from 'react'

/**
 * Ported from legacy `hooks/use-mobile.tsx`, breakpoint included.
 *
 * Kitchen and POS run on tablets (§14.9), so this decides real layout, not a
 * cosmetic detail — 768 px is where the sidebar becomes a drawer.
 */
const MOBILE_BREAKPOINT_PX = 768

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    const query = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX - 1}px)`)
    const sync = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT_PX)

    query.addEventListener('change', sync)
    sync()
    return () => query.removeEventListener('change', sync)
  }, [])

  return isMobile
}
